import { render, staticRenderFns } from "./TipoVentaComponent.vue?vue&type=template&id=5d4b4e50"
import script from "./TipoVentaComponent.vue?vue&type=script&lang=js"
export * from "./TipoVentaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports